import React from "react";
import { Box, Grid} from "@mui/material";
import {
  InfoOutlined,
  LocalShippingOutlined,
  DateRangeOutlined,
  TextSnippetOutlined,
  Person,
  TextSnippet,
  CommentOutlined,
  ErrorOutlineOutlined,
  LocationOnOutlined,
  DirectionsCarFilledOutlined,
} from "@mui/icons-material";

import { useDataIntegrationDetailContext } from "contexts/DataIntegrationDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";

const DataIntegrationBasicDetail = () => {
  const { dataIntegrationDetail, loadingDataIntegration } =
    useDataIntegrationDetailContext();

  return !loadingDataIntegration ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        {/* Integration ID */}

        <Grid item xs={4}>
          <InformationTile
            icon={() => <TextSnippetOutlined color="primary" />}
            title="Integration ID"
            subtitle={
              dataIntegrationDetail?.integrationId &&
              typeof dataIntegrationDetail.integrationId === "object"
                ? dataIntegrationDetail.integrationId.integrationId
                : dataIntegrationDetail?.integrationId
            }
          />
        </Grid>
        {/* externalSystemId */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="externalSystemId"
            subtitle={
              dataIntegrationDetail?.externalSystemId &&
              typeof dataIntegrationDetail.externalSystemId === "object"
                ? dataIntegrationDetail.externalSystemId.externalSystemId
                : dataIntegrationDetail?.externalSystemId
            }
          />
        </Grid>
        {/* statusUpdate */}

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="statusUpdate"
            subtitle={
              dataIntegrationDetail?.statusUpdate &&
              typeof dataIntegrationDetail.statusUpdate === "object"
                ? dataIntegrationDetail.statusUpdate.statusUpdate
                : dataIntegrationDetail?.statusUpdate
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <TextSnippet color="primary" />}
            title="documentType"
            subtitle={
              dataIntegrationDetail?.documentType &&
              typeof dataIntegrationDetail.documentType === "object"
                ? dataIntegrationDetail.documentType.documentType
                : dataIntegrationDetail?.documentType
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <TextSnippet color="primary" />}
            title="documentType"
            subtitle={
              dataIntegrationDetail?.documentUrl &&
              typeof dataIntegrationDetail.documentUrl === "object"
                ? dataIntegrationDetail.documentUrl.documentUrl
                : dataIntegrationDetail?.documentUrl
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <CommentOutlined color="primary" />}
            title="comment"
            subtitle={
              dataIntegrationDetail?.comment &&
              typeof dataIntegrationDetail.comment === "object"
                ? dataIntegrationDetail.comment.comment
                : dataIntegrationDetail?.comment
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <ErrorOutlineOutlined color="primary" />}
            title="errorDetail"
            subtitle={
              dataIntegrationDetail?.errorDetail &&
              typeof dataIntegrationDetail.errorDetail === "object"
                ? dataIntegrationDetail.errorDetail.errorDetail
                : dataIntegrationDetail?.errorDetail
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Timestamp"
            subtitle={
              dataIntegrationDetail?.timestamp
                ? localizeDateTimeShort(
                    typeof dataIntegrationDetail.timestamp === "object"
                      ? dataIntegrationDetail.timestamp.timestamp
                      : dataIntegrationDetail.timestamp
                  )
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Loading Location"
            subtitle={`lat: ${dataIntegrationDetail?.location?.lat},
           lon: ${dataIntegrationDetail?.location?.lon}`}
          />
        </Grid>

        {/* Shipment Request ID */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment Request ID"
            subtitle={
              dataIntegrationDetail?.shipmentId &&
              typeof dataIntegrationDetail.shipmentId === "object"
                ? dataIntegrationDetail.shipmentId.shipmentId
                : dataIntegrationDetail?.shipmentId
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="status"
            subtitle={
              dataIntegrationDetail?.status &&
              typeof dataIntegrationDetail.status === "object"
                ? dataIntegrationDetail.status.status
                : dataIntegrationDetail?.status
            }
          />
        </Grid>

        {/* Assigned Vehicle */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <DirectionsCarFilledOutlined color="primary" />}
            title="Assigned Vehicle"
            subtitle={
              dataIntegrationDetail?.vehicleId &&
              typeof dataIntegrationDetail.vehicleId === "object"
                ? dataIntegrationDetail.vehicleId.vehicle_id
                : dataIntegrationDetail?.vehicleId
            }
          />
        </Grid>

        {/* Assigned Driver */}
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Assigned Driver"
            subtitle={
              dataIntegrationDetail?.driverId &&
              typeof dataIntegrationDetail.driverId === "object"
                ? dataIntegrationDetail.driverId.driverId
                : dataIntegrationDetail?.driverId
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default DataIntegrationBasicDetail;
